import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";
import { DataGrid, GridColumnMenu } from "@mui/x-data-grid";
import Loader from "../../components/common/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { SERVER_ORIGIN } from "../../utilities/constants";
import HeaderCard from "../../components/common/HeaderCard";
import BackButton from "../../components/common/BackButton";
import { getDashboardPath } from "../../utilities/helper_functions";

import css from "../../css/admin/users-page.module.css";

const MouDetails = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [allData, setAllData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const regionId = params.get("regionId");
  const mouType = params.get("mouType") || "Single"; // default Single

  useEffect(() => {
    async function fetchMouData() {
      setIsLoading(true);
      try {
        const response = await fetch(
          `${SERVER_ORIGIN}/api/admin/auth/region/chapterdata?regionId=${regionId}&mouType=${mouType}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "auth-token": sessionStorage.getItem("token"),
            },
          }
        );

        const result = await response.json();
        setIsLoading(false);

        if (response.status >= 400) {
          if (response.status === 401) {
            navigate("/admin/login");
          } else {
            toast.error(result.statusText);
          }
        } else if (response.status === 200) {
          setAllData(result.data || []);
        }
      } catch (err) {
        setIsLoading(false);
        toast.error("Something went wrong!");
      }
    }

    fetchMouData();
  }, [regionId, navigate]);

  const filteredRows = allData
    .filter((row) =>
      row.chapterName.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .map((row, idx) => ({ ...row, id: idx + 1 }));

  const columns = [
    { field: "id", headerName: "ID", width: 250 },
    { field: "region", headerName: "Region", width: 200 },
    { field: "chapterName", headerName: "Chapter Name", width: 200 },
    // { field: "noOfMoUs", headerName: "No. of MoUs", width: 200 },
    {
      field: "noOfMoUs",
      headerName:
        mouType === "Single" ? "Single No. of MoUs" : "Bulk No. of MoUs",
      width: 200,
    },

    { field: "noOfStudents", headerName: "No. of Students", width: 200 },
    {
      field: "editDetails",
      headerName: "Action",
      type: "actions",
      width: 150,
      align: "center",
      renderCell: (params) => (
        <button
          className={css.viewBtn}
          onClick={
            () =>
              // navigate(
              //   `/region/institutes-details?chapterName=${encodeURIComponent(
              //     params.row.chapterName
              //   )}&mouType=Single`
              // )
              navigate(
                `/region/institutes-details?chapterName=${encodeURIComponent(
                  params.row.chapterName
                )}&mouType=${mouType}` // ✅ pass same mouType forward
              )
            // navigate(`/region/institutes-details?chapterName=${chapterName}`)
          }
        >
          View
        </button>
      ),
    },
    // { field: "action", headerName: "Action", width: 200 },
  ];

  function CustomColumnMenu(props) {
    return <GridColumnMenu {...props} />;
  }

  return (
    <div className={css.outerDiv}>
      <div>
        <BackButton text="Back to Dashboard" customPath={getDashboardPath()} />
        <h1 className="headerTitle">MoU Details ({regionId})</h1>
        <hr />
        {/* <p className="headerSubtitle">You can view all chapters with MoUs.</p> */}
      </div>

      {/* Search */}
      <div className={css.filterBtns}>
        <div className={css.searchInputs}>
          <div
            className="d-flex"
            style={{
              position: "relative",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              value={searchQuery}
              placeholder="Search by chapter name"
              onChange={(e) => setSearchQuery(e.target.value)}
              className={css.searchInput}
            />
            <FontAwesomeIcon
              icon={faMagnifyingGlass}
              style={{
                color: "black",
                position: "absolute",
                right: "10px",
              }}
            />
          </div>
        </div>
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 7, page: 0 },
              },
            }}
            pageSizeOptions={[7, 10, 20]}
            slots={{ columnMenu: CustomColumnMenu }}
          />
        </div>
      )}
    </div>
  );
};

export default MouDetails;
